import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import api from '../services/api';

/**
 * Fetches a Qora Assistant image attachment (auth-gated) and returns it as a
 * data URL usable in <img src>. Skipped when `path` is undefined (e.g. when an
 * optimistic local preview is already available).
 */
export const useAssistantImage = (path: string | undefined) => {
  return useQuery({
    queryKey: ['assistantImage', path],
    queryFn: async () => {
      if (!path) return null;
      try {
        const response = await api.get('/uploads/assistant/image', {
          params: { path },
          responseType: 'blob',
        });
        return new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result as string);
          reader.onerror = reject;
          reader.readAsDataURL(response.data);
        });
      } catch (err: unknown) {
        if (isAxiosError(err) && err.response?.status === 404) {
          return null;
        }
        throw err;
      }
    },
    enabled: !!path,
    staleTime: 5 * 60 * 1000,
  });
};
